<template>
  <div class="TraineeList">
    <XTable
        :api="getTenantTraineeList"
        :state="tenantTraineeList"
        :columns="columns"
        :firstColumn="firstColumn"
        :loading="tenantTraineeListLoading"
        :tableSize="tableSize"
        :layout="layout"
    ></XTable>
    <AddTrainee ref="addTrainee"></AddTrainee>
  </div>
</template>

<script>
import XTable from "@/components/XTable/index.vue";
import {mapActions, mapState} from "vuex";
import {SEX} from "@/utils/constants";
import DateUtil from "@/utils/formatDate";
import AddTrainee from "@/pages/TraineeManagement/AddTrainee.vue";

export default {
  name: "TraineeList",
  components: {AddTrainee, XTable},
  data() {
    return {
      tableSize: "small",
      layout: "sizes, prev, pager, next",
      firstColumn: false,
    };
  },
  computed: {
    ...mapState("administrativeCenter", ["tenantTraineeListLoading", "tenantTraineeFilter", "tenantTraineeList"]),
    ...mapState("user", ["permissionCode"]),
    columns: function () {
      const self = this;
      const columns = [
        {
          prop: "nickname",
          label: "姓名",
        },
        {
          prop: "phone",
          label: "手机号码",
        },
        {
          prop: "unitName",
          label: "工作单位",
        },
        {
          label: "性别",
          render(h, scope) {
            return (
                <div>
                  <span>{SEX[scope.row.sex]}</span>
                </div>
            );
          },
        },
        {
          label: "生日",
          render(h, scope) {
            return (
                <div>
                  <span>{self.formatDate(scope.row.birthday)}</span>
                </div>
            );
          },
        },
        {
          label: "上次登录",
          render(h, scope) {
            return (
                <div>
                  <span>{self.formatDate(scope.row.loginTime)}</span>
                </div>
            );
          },
        },
        {
          label: "创建时间",
          render(h, scope) {
            return (
                <div>
                  <span>{self.formatDate(scope.row.registerTime)}</span>
                </div>
            );
          },
        },
      ];
      if (this.permissionCode.has('admin:trainee:manager')) {
        columns.push({
          label: "操作",
          width: 250,
          render(h, scope) {
            let manager = self.permissionCode.has('admin:trainee:manager');
            return (<div>
              {manager && (
                  <el-button
                      onClick={() => {
                        self.handleEdit(scope.row);
                      }}
                      size="mini"
                      type="primary"
                      plain>
                    编辑
                  </el-button>
              )}
              {manager && (
                  <el-button
                      onClick={() => {
                        self.handleDelete(scope.row);
                      }}
                      size="mini"
                      type="danger"
                      plain>
                    删除
                  </el-button>
              )}
            </div>)
          }

        })
      }
      return columns;
    }
  },
  methods: {
    ...mapActions("administrativeCenter", ["getTenantTraineeList", "saveTenantTrainee", "deleteTenantTrainee"]),
    //编辑
    async handleEdit(row) {
      this.$refs.addTrainee.initData(row);
    },
    //删除
    async handleDelete(row) {
      this.$confirm("请确认删除学员" + row.nickname, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        await this.deleteTenantTrainee(row.id);
        await this.getTenantTraineeList({});
      })
    },
    //   根据时间戳计算年龄
    formatAge(timestamp) {
      return DateUtil.calculateAgeFromTimestamp(timestamp);
    },
    //   根据时间戳计算日期
    formatDate(timestamp) {
      return DateUtil.formatDateFromTimestamp(timestamp);
    },
  },
};
</script>

<style lang="scss" scoped></style>
